import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api",
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("teacher");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (username, password) => {
    const form = new FormData();
    form.append("username", username);
    form.append("password", password);
    return api.post("/auth/login", form);
  },
  register: (data) => api.post("/auth/register", data),
  changePassword: (current_password, new_password) =>
    api.put("/auth/password", { current_password, new_password }),
};

export const studentAPI = {
  list: () => api.get("/students/"),
  get: (id) => api.get(`/students/${id}`),
  create: (data) => api.post("/students/", data),
  update: (id, data) => api.put(`/students/${id}`, data),
  delete: (id) => api.delete(`/students/${id}`),
  bulk: (file, tabType) => {
    const form = new FormData();
    form.append("file", file);
    return api.post(`/students/bulk?tab_type=${tabType}`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};

export const modelsAPI = {
  list: () => api.get("/models/"),
};

export const batchAPI = {
  start: (data) => api.post("/batch/", data),
  status: (jobId) => api.get(`/batch/${jobId}`),
  cancel: (jobId) => api.delete(`/batch/${jobId}`),
};

export const recordAPI = {
  list: () => api.get("/records/"),
  create: (data) => api.post("/records/", data),
  get: (id) => api.get(`/records/${id}`),
  delete: (id) => api.delete(`/records/${id}`),
  updateDisplayStage: (id, display_stage) => api.patch(`/records/${id}/display-stage`, { display_stage }),
  updateDraft: (id, data) => api.put(`/records/${id}/draft`, data),
  review1: (record_id, model) => api.post("/records/review1", { record_id, model }),
  review2: (record_id, model, note) => api.post("/records/review2", { record_id, model, note }),
  final: (record_id, model, note) => api.post("/records/final", { record_id, model, note }),
};

export const CATEGORIES = [
  { value: "autonomous",     label: "자율활동",              charLimit: 500, needsSubject: false },
  { value: "club",           label: "동아리활동",             charLimit: 500, needsSubject: false },
  { value: "career",         label: "진로활동",              charLimit: 700, needsSubject: false },
  { value: "subject_detail", label: "교과별 세부능력 특기사항", charLimit: 500, needsSubject: true  },
  { value: "behavioral",     label: "행동특성 및 종합의견",    charLimit: 500, needsSubject: false },
];

export const getCategoryInfo = (value) => CATEGORIES.find((c) => c.value === value) || CATEGORIES[0];

export const attachmentAPI = {
  list: (record_id) => api.get(`/attachments/${record_id}`),
  upload: (record_id, files) => {
    const form = new FormData();
    files.forEach((f) => form.append("files", f));
    return api.post(`/attachments/${record_id}`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  delete: (attachment_id) => api.delete(`/attachments/${attachment_id}`),
};

export default api;
